import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject, interval } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import {
  EditInfoComponentOutput,
  EditInfoEditableField,
  EditInfoInputFieldType,
  ResourceFieldToValueMap
} from '@root/src/app/shared/modals/model/edit-info-editable-field';

@Component({
  selector: 'app-rad-edit-info',
  templateUrl: './rad-edit-info.component.html',
  styleUrls: ['./rad-edit-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RadEditInfoComponent implements OnInit {

  @Input() public editableFields: EditInfoEditableField[] = []; // List of all fields which can be edited
  @Input() public errorMsg: string = null;

  @Output() confirm: EventEmitter<EditInfoComponentOutput> = new EventEmitter(); // use EditInfoOutput[] for emit

  updatedFields: BehaviorSubject<EditInfoEditableField[]> = new BehaviorSubject<EditInfoEditableField[]>([]);

  InputFieldType = null;

  getEditableFieldError(item: EditInfoEditableField): string {
    let errorMessage = '';

    if(!item.isOptional && typeof item.currentValue === 'string' && item.currentValue.length === 0) {
      errorMessage += item.mandatoryFieldErrorMessage;
    }

    if(item.maxLength && typeof item.currentValue === 'string' && item.currentValue.length > Number(item.maxLength)) {
      errorMessage += item.maxLengthWarningMessage;
    }

    return errorMessage;
  }

  get showErrorMessageBanner(): boolean {
    return !!this.errorMsg;
  }

  constructor() { }

  ngOnInit() {
    this.InputFieldType = EditInfoInputFieldType;
    this.debounceUserInput();
  }

  private debounceUserInput() {
    this.updatedFields
      .pipe(debounceTime(200))
        .subscribe(updatedFields => {
          const editInfoOutput: EditInfoComponentOutput = {
            newValueMap: this.constructNewFieldToValueMap(),
          };
          this.confirm.emit(editInfoOutput);
        });
  }

  onChangeInputValues($event: EditInfoComponentOutput) {
    this.updatedFields.next(this.editableFields);
  }

  private constructNewFieldToValueMap() {
    const newFieldToValueMap: ResourceFieldToValueMap = {};
    for (const editableField of this.editableFields) {
      newFieldToValueMap[editableField.name] = editableField.currentValue;
    }
    return newFieldToValueMap;
  }

}
